import { createSelector } from 'reselect';

const selectPolls = (state: any) => state.polls;


export const selectPollsCurrentItem = createSelector([selectPolls], (polls) => polls.current);

export const selectPollsListItems = createSelector([selectPolls], (polls) => polls.list);

export const selectPollsItemById = (itemId: any) =>
    createSelector(selectPollsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
export const selectPollsQueryItems = createSelector([selectPolls], (polls) => polls.query);


export const selectPollsCreatedItem = createSelector([selectPolls], (polls) => polls.create);

export const selectPollsUpdatedItem = createSelector([selectPolls], (polls) => polls.update);

export const selectPollsReadItem = createSelector([selectPolls], (polls) => polls.read);

export const selectPollsDeletedItem = createSelector([selectPolls], (polls) => polls.delete);

export const selectPollsSearchedItems = createSelector([selectPolls], (polls) => polls.search);

export const selectPollsItemsCount = createSelector([selectPolls], (polls) => polls.count);

export const selectPollsItemsFilter = createSelector([selectPolls], (polls) => polls.filter);